import { ErrorCode } from '@operations/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useOperationEquipmentMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = () => {
    return t('assignmentsUpdatedSuccessfully', 'Assignments updated successfully')
  }

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCode.EntityNotFound) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      } else if (errorDescription.code === ErrorCode.EntityListNotFound) {
        errors.push(
          t('entitiesNotFound', '{entity} with Ids {ids} not found', {
            entity: errorDescription.payload?.name,
            ids: errorDescription.payload?.ids?.join(', '),
          }),
        )
      } else if (errorDescription.code === ErrorCode.FieldMustBeUnique) {
        errors.push(
          t('fieldMustBeUnique', '{field} must be unique', {
            field: errorDescription.propertyName,
          }),
        )
      } else if (
        errorDescription.code === ErrorCode.EquipmentAssignmentEquipmentTypeNotAvailableForCarriers
      ) {
        errors.push(
          t(
            'equipmentNotAssignableForCarrier',
            'The equipment of {type} is not assignabled to the carrier',
            {
              type: errorDescription.payload?.equipmentType,
            },
          ),
        )
      } else if (
        errorDescription.code === ErrorCode.EquipmentAssignmentEquipmentTypeNotAvailableForYard
      ) {
        errors.push(
          t(
            'equipmentNotAssignableForYard',
            'The equipment of {type} is not assignabled to the yard',
            {
              type: errorDescription.payload?.equipmentType,
            },
          ),
        )
      } else if (
        errorDescription.code === ErrorCode.EquipmentCannotBeSetToInactiveBecauseAssignedToVisit
      ) {
        errors.push(
          t(
            'equipmentCannotBeSetToInactiveBecauseAssignedToVisit',
            'The equipment {name} cannot be set to inactive, because it assigned to visits {assignedVisits} that are not departed yet',
            {
              name: errorDescription.payload?.name,
              assignedVisits: errorDescription.payload?.assignedVisits,
            },
          ),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
